import React, { Component, Fragment } from "react";
import { setLoader, setDeeplink, setParams } from "../../../../redux/actions";
import {
  Row,
  Button,
  Alert
} from "reactstrap";
import Field from "../../../../components/utils/Field"
import { Colxx } from "../../../../components/common/CustomBootstrap";
import _axios from "../../../../libs/axios";
import { NotificationManager } from "../../../../components/common/react-notifications";
import FormCustom from "../../../../components/utils/FormCustom";
import AppLocale from "../../../../config/lang";
import { connect } from "react-redux";
import { cloneDeep, debounce } from "lodash"
import _moment from "../../../../libs/moment";

const M = "admAttendance."

class AdmAttendanceControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resource: null,
      data: [],
      dataTemp: [],
      progressBar: false,
      formFilter: {
        sessionId: null
      },
      sessionId: null,
      sessions: [],
      overlay: true,
      userAdmin: props.userAdmin,
      showPartId: false
    };
  }

  UNSAFE_componentWillMount() {
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState) {
  }

  componentWillUnmount() {
    this.props.setParams(null)
  }

  getSessions(ctxFormFilter) {
    this.setState({ progressBar: true, data: [], dataTemp: [], sessions: [] });
    let date = cloneDeep(this.state.formFilter.date)

    // For groups mode, use admSubject instead of partId
    let endpoint;
    if (this.state.formFilter.type === 2 && this.state.formFilter.subjectId) {
      // For groups mode, the endpoint returns students directly, not sessions
      endpoint = 'admAttendance/group/' + this.state.formFilter.groupId.value + '/' + this.state.formFilter.subjectId.value + '/' + date + '/list'
      _axios
        .get(endpoint)
        .then(r => {
          if (r.status >= 0) {
            // Groups mode returns students directly
            let status = this.state.formFilter ? this.state.formFilter.status : -1
            let temp = status === -1 ? r.data : r.data.filter(e => e.status === status)
            let allPending = r.data.length > 0 && r.data.every(e => !e.status || e.status === 0)
            this.setState({ data: r.data, dataTemp: temp, overlay: allPending, progressBar: false })
          } else {
            NotificationManager.error(r.msg, 'Opps', 5000, null, null, 'outline')
            this.setState({ progressBar: false })
          }
        })
      return
    } else if (this.state.formFilter.partId) {
      endpoint = 'admAttendance/' + this.state.formFilter.partId.value + '/sessions?dt='+ date+'&sectionId='+(this.state.formFilter.sectionId ? this.state.formFilter.sectionId : -1)+'&groupId='+(this.state.formFilter.groupId ? this.state.formFilter.groupId.value : -1)
    } else {
      this.setState({ progressBar: false })
      return
    }

    _axios
      .get(endpoint)
      .then(r => {
        if (r.status >= 0) {
          let sessions = r.data.filter(e => e.date && e.date.indexOf(_moment(date).format('YYYY-MM-DD')) > -1)

          let items = []
          sessions.forEach(e => {
            items.push({ value: e.ID, label: _moment(e.date).format('HH:mm'), registrationStarted: e.registrationStarted})
          });
          this.setState({ sessions: items })

          if (sessions.length === 1) {
            let formFilter = cloneDeep(this.state.formFilter)
            formFilter.sessionId = sessions[0].ID
            this.setState({ formFilter:  formFilter}, () => {
              // Keep FormCustom state in sync so the session is visible in the UI.
              if (ctxFormFilter && ctxFormFilter.setState) {
                ctxFormFilter.setState({ sessionId: sessions[0].ID })
              }
              // Programmatic setState in FormCustom doesn't fire field onChange,
              // so load data directly when there is only one session.
              this.getData(sessions[0].ID)
            })
          } else {
            this.setState({ progressBar: false })
          }
        } else NotificationManager.error(r.msg, 'Opps', 5000, null, null, 'outline')
      })
  }

  getData(id) {
    this.setState({ progressBar: true, data: [], dataTemp: [] });
    
    // For groups mode, sessions are already fetched by getSessions, so use different endpoint
    let endpoint;
    if (this.state.formFilter.type === 2 && this.state.formFilter.subjectId) {
      // For groups mode, the list is already fetched in getSessions, just get session details
      endpoint = 'admAttendance/' + this.state.formFilter.subjectId.value + '/sessions/'+ id + '/list'
    } else if (this.state.formFilter.partId) {
      endpoint = 'admAttendance/' + this.state.formFilter.partId.value + '/sessions/'+ id + '/list?sectionId='+ (this.state.formFilter.sectionId ? this.state.formFilter.sectionId : -1)+'&groupId='+(this.state.formFilter.groupId ? this.state.formFilter.groupId.value : -1)
    } else {
      this.setState({ progressBar: false })
      return
    }
    
    _axios
      .get(endpoint)
      .then(r => {
        if (r.status >= 0) {
          let status = this.state.formFilter ? this.state.formFilter.status : -1
          let temp = status === -1 ? r.data : r.data.filter(e => e.status === status)
          let session = this.state.sessions.find( f => f.value === this.state.formFilter.sessionId)
          let allPending = session ? !session.registrationStarted : false
          this.setState({ data: r.data, dataTemp: temp, overlay: allPending }, () => { this.setState({ progressBar: false }) })
        } else NotificationManager.error(r.msg, 'Opps', 5000, null, null, 'outline')
      })
  }

  startAttendance() {
    // console.log(this.state.formFilter.sessionId)

    if (!this.state.formFilter || (this.state.formFilter.type !== 2 && !this.state.formFilter.sessionId)) {
      NotificationManager.error('Debe seleccionar una sesión válida para iniciar la asistencia.', 'Opps', 5000, null, null, 'outline')
      return
    }

    let sessionId = this.state.formFilter.type === 2 ? -1 : this.state.formFilter.sessionId
    let query = this.state.formFilter.type === 2
      ? '?date=' + this.state.formFilter.date + '&activityId=' + this.state.formFilter.subjectId.value + '&sectionId=-1&groupId=' + (this.state.formFilter.groupId ? this.state.formFilter.groupId.value : -1)
      : '?sectionId=' + this.state.formFilter.sectionId + '&groupId=' + (this.state.formFilter.groupId ? this.state.formFilter.groupId.value : -1)

    this.props.setLoader(true)
    _axios
      .post('admAttendance/session/' + sessionId + '/init' + query)
      .then(r => {
        if (r.status >= 0) {
          if (this.state.formFilter.type !== 2) {
            this.state.sessions.find( f => f.value === this.state.formFilter.sessionId).registrationStarted = true
            this.setState({ overlay: false }, () => {
              this.getData(this.state.formFilter.sessionId)
            })
          } else {
            this.setState({ overlay: false }, () => {
              this.getSessions()
            })
          }
        }
        NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
        this.props.setLoader(false)
      })
      .catch((e) => { this.props.setLoader(false) })
  }

  save(item, status) {
    let body = [
      {
        userId: item.id,
        comment: item.comment,
        status: status
      }
    ]

    // For groups mode, use sessionId=0 with date and activityId params
    let endpoint, sessionId
    if (this.state.formFilter.type === 2) {
      sessionId = 0
      endpoint = 'admAttendance/session/' + sessionId + '/status?date=' + this.state.formFilter.date + '&activityId=' + this.state.formFilter.subjectId.value
    } else {
      sessionId = this.state.formFilter.sessionId
      endpoint = 'admAttendance/session/' + sessionId + '/status'
    }

    _axios
      .post(endpoint, body)
      .then(r => {
        if (r.status >= 0) {
          let data = cloneDeep(this.state.data)
          data.map(e => {
            if (e.id === item.id) {
              e.comment = item.comment
              e.status = status
            }
            return e
          })

          let temp = cloneDeep(this.state.dataTemp)
          temp.map(e => {
            if (e.id === item.id) {
              e.comment = item.comment
              e.status = status
              e.click = true
            }
            return e
          })
          this.setState({ data: data, dataTemp: temp })
        }
        NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
      })
      .catch((e) => { })
  }

  execute = debounce((item, status) => { this.save(item, status) }, 500, { leading: true })

  saveComment (item) {
    if (item.status === 0) {
      NotificationManager.error('La observación no se ha guardado, se guardará cuando marque la asistencia respectiva', '', 5000, null, null, 'outline')
      return
    }
    let body = [
      {
        userId: item.id,
        comment: item.comment
      }
    ]

    let data = cloneDeep(this.state.data)
    let temp = cloneDeep(this.state.dataTemp)

    data.map(e => {
      if (e.id === item.id) {
        e.processing = true
      }
      return e
    })

    temp.map(e => {
      if (e.id === item.id) {
        e.processing = true
      }
      return e
    })

    this.setState({ data: data, dataTemp: temp })

    // For groups mode, use sessionId=0 with date and activityId params
    let endpoint, sessionId
    if (this.state.formFilter.type === 2) {
      sessionId = 0
      endpoint = 'admAttendance/session/' + sessionId + '/comment?date=' + this.state.formFilter.date + '&activityId=' + this.state.formFilter.subjectId.value
    } else {
      sessionId = this.state.formFilter.sessionId
      endpoint = 'admAttendance/session/' + sessionId + '/comment'
    }

    _axios
      .post(endpoint, body)
      .then(r => {
        if (r.status >= 0) {
          data.map(e => {
            if (e.id === item.id) {
              e.comment = item.comment
              e.processing = false
            }
            return e
          })

          data.map(e => {
            if (e.id === item.id) {
              e.comment = item.comment
              e.processing = false
            }
            return e
          })
          this.setState({ data: data, dataTemp: temp })
        }
        NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
      })
      .catch((e) => { })
  }

  listenStatesFormFilter = (s) => {
    this.setState({ formFilter: s });
  }

  listenBtnActionsFormFilter = (a, s, rowData) => {
  }

  filterData = () => {
    if (!this.state.formFilter) return []
    else if (this.state.formFilter.search && this.state.formFilter.search !== "") {
      return this.state.dataTemp.filter(e => {
        return e.name.toLowerCase().includes(this.state.formFilter.search.toLowerCase()) || e.last.toLowerCase().includes(this.state.formFilter.search.toLowerCase())
      })
    } else {
      return this.state.dataTemp
    }
  }

  shouldShowStartAttendanceButton = () => {
    const hasStudents = this.state.dataTemp.length > 0
    if (!hasStudents) return false
    return this.state.overlay
  }

  render() {
    const { locale, params } = this.props
    const L = AppLocale[locale].messages
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Row>
              <Colxx xxs="12" xxl="6">
                {/* TITLE */}
                <h1>Asistencia</h1>
              </Colxx>
            </Row>

            {params?.setupMsg && <Alert className="rounded" color="warning">{params.setupMsg}</Alert>}

            {/* FILTERS */}
            <FormCustom
              id={"form-flt"}
              fields={
                [
                  {
                    name: "date",
                    value: _moment().format('YYYY-MM-DD'),
                    type: "date",
                    label: `${M}activitiesDuring`,
                    opts: {
                      style: 'float-label',
                    },
                    onChange: (ctx) => {
                      this.setState({ data: [], dataTemp: [] })
                    },
                  },
                  {
                    name: "type",
                    value: null,
                    type: "select",
                    label: "main.type",
                    parent: "date",
                    opts: {
                      style: 'float-label',
                      items: [
                        {value: true, label: L[`${M}typeDaily`]},
                        {value: false, label: L[`${M}typeCourse`]},
                        {value: 2, label: L[`${M}typeGroup`]},
                      ]
                    },
                    onChange: (ctx) => {
                      this.setState({sessionId: null, sessions: []})
                      if (ctx.state.type === true) {
                        _axios
                        .get('/admAttendance?dt=' + ctx.state.date + '&masterId='+this.state.userAdmin.ID + '&daily=' + ctx.state.type)
                        .then(r => {
                          if (r.status >= 0) {
                            if (!r.data) return r
                            // r.data.splice(1,2)
                            this.setState({showPartId: r.data.length > 1}, () => {
                              if (r.data.length === 1) ctx.setState({partId: { value: r.data[0].ID, label: r.data[0].name, original: r.data[0] }})
                            })
                          } else {
                            NotificationManager.error(r.msg, 'Opps', 5000, null, null, 'outline')
                            this.setState({showPartId: false})
                          }
                        })
                      } else if (ctx.state.type === false)  this.setState({showPartId: true})
                      else if (ctx.state.type === 2) this.setState({showPartId: true})
                    },
                    renderIf: (ctx) => { return ctx.state.date }
                  },
                  {
                    name: "groupId",
                    value: null,
                    type: "select",
                    label: "Grupo",
                    parent: "type",
                    opts: {
                      style: 'float-label',
                      path: () => { return "/admGroup/get?pick=true&staff=" + (this.props.userAdmin.role !== '100' ? '1' : '0') + (this.props.userAdmin.role !== '100' ? '&meIn=true' : '') },
                      setOutput: v => { if (v) return {value: v.value, label: v.label} }
                    },
                    onChange: (ctx) => {
                      // Reset subject and partId when grupo changes
                      ctx.setState({ partId: null, subjectId: null });
                      this.setState({ sessionId: null, sessions: [], data: [], dataTemp: [] });
                    },
                    renderIf: (ctx) => { return ctx.state.type === 2 }
                  },
                  {
                    name: "subjectId",
                    value: null,
                    type: "select",
                    label: "Curso",
                    parent: "groupId",
                    opts: {
                      style: 'float-label',
                      isClearable: false,
                      path: (ctx) => { return '/admSubject/get?pick=true&groupId=' + ctx.state.groupId.value },
                      setOutput: v => v,
                    },
                    onChange: (ctx) => {
                      if (ctx.state.subjectId) process.nextTick(() => {
                        this.getSessions(ctx) 
                      })
                    },
                    renderIf: (ctx) => { return ctx.state.type === 2 && ctx.state.groupId }
                  },
                  {
                    name: "partId",
                    value: null,
                    type: "select",
                    label: "main.course",
                    parent: "type",
                    opts: {
                      style: 'float-label',
                      isClearable: false,
                      path: (ctx) => { return '/admAttendance?dt=' + ctx.state.date + '&masterId='+this.state.userAdmin.ID + '&daily=' + ctx.state.type + (ctx.state.groupId ? '&groupId=' + ctx.state.groupId.value : '') },
                      remap: (r, ctx) => {
                        if (!r.data) return r
                        r.data.Results = r.data
                        return r
                      },
                      setOutput: v => v,
                    },
                    onChange: (ctx) => {
                      if (ctx.state.partId) process.nextTick(() => {
                        this.getSessions(ctx) 
                      })
                    },
                    renderIf: (ctx) => { return (ctx.state.type === true || ctx.state.type === false) && this.state.showPartId }
                  },
                  {
                    name: "sessionId",
                    value: null,
                    type: "select",
                    label: "main.session",
                    opts: {
                      style: 'float-label',
                      items: this.state.sessions,
                      isClearable: false,
                    },
                    onChange: (ctx) => {
                      // console.log(ctx.state.sessionId)
                      if (ctx.state.sessionId) process.nextTick(() => {
                        this.getData(ctx.state.sessionId)
                      })
                    },
                    renderIf: (ctx) => { return this.state.sessions.length > 0 && (ctx.state.type === false || ctx.state.type === 2) }
                  },
                  {
                    name: "sectionId",
                    value: -1,
                    type: "select",
                    label: "main.section",
                    opts: {
                      style: 'float-label',
                      path: () => { return "/admSection/get?roleFilter=sectionOwner&pick=true" }
                    },
                    onChange: (ctx) => {
                      if (ctx.state.sectionId) process.nextTick(() => {
                        this.getSessions(ctx) 
                      })
                    },
                    renderIf: (ctx) => { return ctx.state.type !== 2 && ctx.state.partId && (ctx.state.type === true || ctx.state.partId.original.regist > 0) }
                  },
                  {
                    name: "status",
                    value: -1,
                    type: "select",
                    label: "main.filter",
                    opts: {
                      style: 'float-label',
                      isClearable: false,
                      items: [
                        {value: -1, label: 'TODOS'},
                        {value: 0, label: 'PENDIENTES'},
                        {value: 1, label: 'PRESENTES'},
                        {value: 2, label: 'TARDE'},
                        {value: 3, label: 'AUSENTES'},
                      ]
                    },
                    onChange: (ctx) => {
                      let data = cloneDeep(this.state.data)
                      data.map(e => e.click = false)
                      let temp = ctx.state.status === -1 ? data : data.filter(e => e.status === ctx.state.status)
                      this.setState({ dataTemp: temp })
                    },
                    renderIf: (ctx) => { return ((ctx.state.partId && ctx.state.partId.value) || (ctx.state.subjectId && ctx.state.subjectId.value)) && (!ctx.state.search || ctx.state.search === "") }
                  },
                  {
                    name: "search",
                    value: "",
                    type: "text",
                    label: "main.search",
                    placeholder: "main.studentFirstOrLastName",
                    opts: {
                      style: 'float-label',
                    },
                    onChange: (ctx) => {
                      let data = cloneDeep(this.state.data)
                      data.map(e => e.click = false)
                      this.setState({ dataTemp: data })
                    },
                  },
                ]
              }
              listenStates={this.listenStatesFormFilter}
            />
          </Colxx>
        </Row>

        {this.shouldShowStartAttendanceButton() && this.filterData().length > 0 &&
        <Row>
          <Colxx xxs="12" className="d-flex justify-content-end mb-4">
            <Button type="button" color="primary" className="mr-2" onClick={() => { this.startAttendance() }}>
              {L[`${M}startAttendance`]}
            </Button>
          </Colxx>
        </Row>
        }

        {/* GRID */}
        <Row>
          <Colxx xxs="12">
            {this.state.progressBar && <div className="progress"><div className="indeterminate"></div></div>}
            {this.filterData().length === 0 && !this.state.progressBar && <div className="fadeIn">{L["main.noRecords"]}</div>}
            {this.filterData().length > 0 &&
            <div className="margin-bottom-60 card fadeIn" ref={el => (this.componentRef = el)}>
              {this.state.overlay && <div className="attendance-overlay"></div>}
              <div className="notas" id="adm-attendance-control">   

                <div className="notas-left">
                  <div className="notas-spacer" id="notas-header-pupil">
                    <div className="notas-title text-uppercase">{L["main.student"]}</div>
                  </div>

                  {/* Stundents */}
                  {this.filterData().map((item, i) => {
                    return (
                      <div className="notas-item" key={i.toString()}>
                        <div className="notas-face">
                          <img src={item.img ? item.img : require("../../../../assets/img/user.png")} onError={(e)=>{e.target.onerror = null; e.target.src=require("../../../../assets/img/user.png")}} alt=""/>
                        </div>
                        <div className="notas-name">{item.last + ' ' + item.name}</div>
                      </div>
                    )})
                  }
                </div>

                <div className="notas-right" id="attendance-side-right">
                  <div className="notas-header" id="notas-header">
                    <div className="notas-row">
                      <div className="notas-col">
                        <div className="notas-name">{L[`${M}attendance`]}</div>
                      </div>
                      <div className="notas-col info">
                        <div className="notas-name">{L["main.justification"]}</div>
                      </div>
                      <div className="notas-col">
                        <div className="notas-name">{L["main.observations"]}</div>
                      </div>
                    </div>
                  </div>

                  <div className="notas-numbers" id="notas-number">

                    {/* Stundents */}
                    {this.filterData().map((item, i) => {
                      return (
                        <div className="notas-row" key={i.toString()}>
                          <div className={"notas-col"}>
                            <Button
                              color={(item.status === 1 ? "primary" : "light")}
                              className={"cs-btn default mr-2 " + (item.click ? " opacity-25" : "")}
                              onClick={() => { this.execute(item, 1) }}
                              disabled={item.processing || item.status === 1}
                            >
                              <i className="text-one simple-icon-check"></i>
                            </Button>
                            <Button
                              color={(item.status === 2 ? "primary" : "light")}
                              className={"cs-btn default mr-2 " + (item.click ? " opacity-25" : "")}
                              onClick={() => { this.execute(item, 2) }}
                              disabled={item.processing || item.status === 2}
                            >
                              <i className="text-one simple-icon-clock"></i>
                            </Button>
                            <Button
                              color={(item.status === 3 ? "primary" : "light")}
                              className={"cs-btn default " + (item.click ? " opacity-25" : "")}
                              onClick={() => { this.execute(item, 3) }}
                              disabled={item.processing || item.status === 3}
                            >
                              <i className="text-one simple-icon-close"></i>
                            </Button>
                          </div>
                          <div className={"notas-col d-inline-flex info"}>
                              {item.justifType}
                          </div>
                          <div className={"notas-col d-inline-flex"}>
                            <Field
                              col="9"
                              name={"comment-" + i}
                              value={item.comment}
                              type="text"
                              placeholder="Observación"
                              onChange={(n) => {
                                let temp = cloneDeep(this.state.dataTemp)
                                temp.map(e => {
                                  if (e.id === item.id) e.comment = n
                                  return e
                                })
                                this.setState({dataTemp: temp}, () => {
                                  // console.log(this.state.data)
                                })
                              }}
                              onFocus={() => {
                                const sideRight = document.getElementById('attendance-side-right')
                                sideRight.scrollLeft = sideRight.scrollWidth
                              }}
                            />
                            <div className="col-sm-3">
                              <Button
                                color={"primary"}
                                className={"cs-btn default " + (item.comment !== this.state.data.find(e => e.id === item.id).comment ? "d-block" : "d-none" )}
                                onClick={() => { this.saveComment(item) }}
                              >
                                Guardar
                              </Button>
                            </div>
                          </div>
                        </div>
                      )})
                    }
                  </div>
                </div>

              </div>
            </div>
            }
          </Colxx>
        </Row>
      </Fragment>
    )
  }
}

const mapStateToProps = ({ settings, menu, utils, authUser }) => {
  const { menuItems } = menu;
  const { locale } = settings
  const { deepLink, params } = utils
  const { userAdmin } = authUser;
  return { locale, menuItems, deepLink, params, userAdmin };
};

export default connect(mapStateToProps, { setLoader, setDeeplink, setParams })(AdmAttendanceControl);